<template>
  <div class="calendario mb-2">
    <div class="fc fc-ltr fc-grid row mx-n1">
      <div class="col p-1" style="min-height: 53px;">
        <div class="fc-day-content">
          <div style="height: 29px;">10%</div>
        </div>
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">NEM</span>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px;">
        <div class="fc-day-content">
          <div style="height: 29px;">15%</div>
        </div>
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Ranking</span>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px;">
        <div class="fc-day-content">
          <div style="height: 29px;">20%</div>
        </div>
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Lenguaje y Comunicación</span>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px;">
        <div class="fc-day-content">
          <div style="height: 29px;">30%</div>
        </div>
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Matemáticas</span>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px;">
        <div class="fc-day-content">
          <div style="height: 29px;">
            0%
            <!--<span class="ml-3">ó</span>-->
          </div>
        </div>
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Historia y Cs. Sociales</span>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px;">
        <div class="fc-day-content">
          <div style="height: 29px;">25%</div>
        </div>
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Ciencias</span>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px;">
        <div class="fc-day-content">
          <div style="height: 29px;">450</div>
        </div>
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Ponderado mínimo</span>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px;">
        <div class="fc-day-content">
          <div style="height: 29px;">450</div>
        </div>
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">
            Promedio mínimo
            <br />L y M
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Ponderaciones"
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/fichaCarreraTP/Ponderaciones.vue